'use client';

import { c as _c } from "react/compiler-runtime";
import { SimpleModal } from '@7f-ui/components/modal/simple-modal';
import type { MerchantObject } from '@data-access/graphql/schema.types';
import { shopTestId } from '@utils/utils-shop-test-ids';
import { isCountryCode } from 'src/shared/utils/is-country-code';
import { ImprintContent } from './imprint-content';
const COUNTRY_LABELS: Record<string, string> = {
  AT: 'Österreich',
  CH: 'Schweiz',
  DE: 'Deutschland',
  DK: 'Dänemark',
  FR: 'Frankreich',
  IT: 'Italien',
  LU: 'Luxemburg',
  NL: 'Niederlande'
};
export type MerchantModalProps = {
  merchant: Pick<MerchantObject, 'country' | 'zipCode' | 'city' | 'street' | 'legalForm' | 'companyRegistrationNumber' | 'associationRegistrationNumber' | 'tradeName' | 'legalName' | 'termsLink' | 'privacyLink' | 'vatId'> | null;
  onClose: () => void;
  show: boolean;
};
export function MerchantModal(t0) {
  const $ = _c(26);
  const {
    merchant,
    show,
    onClose
  } = t0;
  if (!merchant) {
    return null;
  }
  let t1;
  if ($[0] !== merchant.city || $[1] !== merchant.country || $[2] !== merchant.street || $[3] !== merchant.zipCode) {
    t1 = () => {
      const country = isCountryCode(merchant.country) ? COUNTRY_LABELS[merchant.country] ?? merchant.country : merchant.country;
      const zipAndCity = `${merchant.zipCode || ""} ${merchant.city || ""}`;
      return [merchant.street, zipAndCity, country];
    };
    $[0] = merchant.city;
    $[1] = merchant.country;
    $[2] = merchant.street;
    $[3] = merchant.zipCode;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const buildAddress = t1;
  const companyRegistrationId = merchant.legalForm === "company" ? merchant.companyRegistrationNumber : null;
  const associationRegistrationId = merchant.legalForm === "non_profit" ? merchant.associationRegistrationNumber : null;
  let t2;
  if ($[5] !== merchant.legalForm) {
    t2 = name => merchant.legalForm === "individual" && name ? `${name} (Unternehmer:in)` : name;
    $[5] = merchant.legalForm;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const withLegalFormSuffix = t2;
  const t3 = `Impressum ${withLegalFormSuffix(merchant.tradeName ?? "")}`;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = shopTestId("MerchantModal.root");
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = merchant.legalName || "";
  let t6;
  if ($[8] !== t5 || $[9] !== withLegalFormSuffix) {
    t6 = withLegalFormSuffix(t5);
    $[8] = t5;
    $[9] = withLegalFormSuffix;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== buildAddress) {
    t7 = buildAddress();
    $[11] = buildAddress;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== associationRegistrationId || $[14] !== companyRegistrationId || $[15] !== merchant.privacyLink || $[16] !== merchant.termsLink || $[17] !== merchant.vatId || $[18] !== t6 || $[19] !== t7) {
    t8 = <div data-testid={t4}><ImprintContent company={t6} address={t7} vatId={merchant.vatId} privacyLink={merchant.privacyLink} termsLink={merchant.termsLink} registrationId={companyRegistrationId} associationId={associationRegistrationId} /></div>;
    $[13] = associationRegistrationId;
    $[14] = companyRegistrationId;
    $[15] = merchant.privacyLink;
    $[16] = merchant.termsLink;
    $[17] = merchant.vatId;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== onClose || $[22] !== show || $[23] !== t3 || $[24] !== t8) {
    t9 = <SimpleModal isOpen={show} onClose={onClose} title={t3}>{t8}</SimpleModal>;
    $[21] = onClose;
    $[22] = show;
    $[23] = t3;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}